import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./css/login.css";

export default function Register() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [role, setRole] = useState("user");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);

  const navigate = useNavigate();

  const handleRegister = () => {
    setError("");

    if (!email || !password) {
      setError("All fields are required");
      return;
    }

    const users = JSON.parse(localStorage.getItem("users")) || [];

    const exists = users.find(u => u.email === email);
    if (exists) {
      setError("User already exists");
      return;
    }

    users.push({ email, password, role });
    localStorage.setItem("users", JSON.stringify(users));

    setSuccess(true);

    // ⏳ Auto hide & redirect
    setTimeout(() => {
      setSuccess(false);
      navigate("/login");
    }, 3000);
  };

  return (
    <>
      {/* 🎯 Toast Popup */}
      {success && (
        <div className="toast toast-success">
          ✅ Registration successful! Redirecting to login...
        </div>
      )}

      <div className="login-container">
        <div className="login-card">
          <h2>ERP Register</h2>

          {error && <div className="error-msg">{error}</div>}

          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={e => setEmail(e.target.value)}
          />

          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={e => setPassword(e.target.value)}
          />

          <select value={role} onChange={e => setRole(e.target.value)}>
            <option value="user">User</option>
            <option value="hr">HR</option>
            <option value="admin">Admin</option>
          </select>

          <button onClick={handleRegister}>Register</button>

          <div className="login-footer">
            Already have an account? <a href="/login">Login</a>
          </div>
        </div>
      </div>
    </>
  );
}